import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';

/**
 * Inits a PhotoSwipe lightbox per root element. Uses dynamic import for core
 * so the larger photoswipe.esm.js loads only when a gallery is present.
 */
document.querySelectorAll('.js-photoswipe-gallery').forEach((gallery) => {
  if (gallery.dataset.pswpInited) {
    return;
  }
  if (!gallery.querySelector('a[href]')) {
    return;
  }

  gallery.dataset.pswpInited = 'true';

  const lightbox = new PhotoSwipeLightbox({
    gallery,
    children: 'a',
    pswpModule: () => import('./photoswipe.esm.js'),
    // Default core value is 0.8; full opacity = stronger dim behind the image
    bgOpacity: 1,
  });

  lightbox.init();
});
